export default "| **S-14** | Tournaments finished: the final result exports as a proposed priority list, readiness checks, notifications | #1281 | Oct 29 |\n"